// Create and configure the WebGPURenderer with dynamic canvas
// Auto-selects WebGPU backend if available, falls back to WebGL2

import { WebGPURenderer } from 'three/webgpu';
import type { RenderCapabilities } from './detect-capabilities';

export interface RendererContext {
  renderer: WebGPURenderer;
  canvas: HTMLCanvasElement;
  dispose: () => void;
}

export function createRenderer(caps: RenderCapabilities): RendererContext {
  const canvas = document.createElement('canvas');
  canvas.id = 'webgl-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.setAttribute('role', 'presentation');
  canvas.style.position = 'fixed';
  canvas.style.top = '0';
  canvas.style.left = '0';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.zIndex = '0';
  canvas.style.pointerEvents = 'none';
  canvas.style.opacity = '0';
  canvas.style.transition = 'opacity 2s ease-in';
  document.body.insertBefore(canvas, document.body.firstChild);

  const renderer = new WebGPURenderer({
    canvas,
    antialias: false,
    alpha: false,
  });

  renderer.setPixelRatio(caps.pixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setClearColor(0x0a0a0f);

  function onResize(): void {
    renderer.setSize(window.innerWidth, window.innerHeight);
  }
  window.addEventListener('resize', onResize);

  function dispose(): void {
    window.removeEventListener('resize', onResize);
    renderer.dispose();
    canvas.remove();
  }

  return { renderer, canvas, dispose };
}
